<!-- Zweck: Stellt die Detaildarstellung des Warenguthabens bereit. -->
<h1 mat-dialog-title>Warenguthaben</h1>
<div mat-dialog-content>
  @if (salden && salden.length > 0) {
    <table class="table table-striped">
      <thead>
      <tr>
        <th>A2-Kundennummer</th>
        <th>Aktueller Saldo</th>
        <th>Mindestbetrag für Abruf</th>
      </tr>
      </thead>
      <tbody>
        @for (saldo of salden; track saldo.A2Kundennummer) {
          <tr>
            <td>{{ saldo.A2Kundennummer }}</td>
            <td>{{ saldo.AktuellerSaldo | number:'1.2-2' }} €</td>
            <td>{{ saldo.MindestSaldoFuerAbruf | number:'1.2-2' }} €</td>
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <p>Es ist derzeit kein Warenguthaben vorhanden.</p>
  }
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Schließen</button>
</div>
